import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductOverride } from "src/app/models/product-override";
import { ProductReference } from "src/app/models/layout/product-reference";
import { ProductShelfPosition } from "src/app/models/layout/product-shelf-position";
import { ProductOrientation } from "src/app/models/layout/product-orientation";
import { LayoutService } from 'src/app/services/layout.service';
import { PlanogramService } from 'src/app/services/planogram.service';
import { ProductOverrideService } from 'src/app/services/product-override.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-override-product-modal',
    templateUrl: './override-product-modal.component.html',
    styleUrls: ['./override-product-modal.component.scss'],
    imports: [FormsModule]
})
export class OverrideProductModalComponent implements OnInit {

  @Input() data!: number;
  productReference: ProductReference | undefined;
  productOverride!: ProductOverride;

  shelfPositionEnum = ProductShelfPosition;
  shelfPositionKeys = Object.keys(this.shelfPositionEnum).filter((v, i) => v == i.toString()).map(v => parseInt(v));
  selectedShelfPosition : any = 0;
  orientationEnum = ProductOrientation;
  orientationKeys = Object.keys(this.orientationEnum).filter((v, i) => v == i.toString()).map(v => parseInt(v));
  selectedOrientation : any = 0;

  constructor(
    public activeModal: NgbActiveModal,
    private layoutService: LayoutService,
    private planogramService: PlanogramService,
    private productOverrideService: ProductOverrideService
  ){ }

  ngOnInit(): void {
    this.productReference = this.layoutService.planogramItems.get(this.data);
    if (this.productReference){
      this.productOverride = this.productOverrideService.getOverride(this.data) ?? new ProductOverride(
        this.data,
        true,
        this.productReference.hFacings,
        this.productReference.vFacings,
        this.productReference.dFacings,
        this.productReference.categoryFlow,
        this.productReference.shelfPosition,
        this.productReference.orientation,
        this.productReference.squeezeW
      );
      if(this.productOverride.hFacings == null){ this.productOverride.hFacings = this.productReference.hFacings; }
      if(this.productOverride.vFacings == null){ this.productOverride.vFacings = this.productReference.vFacings; }
      if(this.productOverride.dFacings == null){ this.productOverride.dFacings = this.productReference.dFacings; }
      if(this.productOverride.categoryFlow == null){ this.productOverride.categoryFlow = this.productReference.categoryFlow; }
      if(this.productOverride.shelfPosition == null){ this.productOverride.shelfPosition = this.productReference.shelfPosition; }
      if(this.productOverride.orientation == null){ this.productOverride.orientation = this.productReference.orientation; }
      if(this.productOverride.squeezeFactor == null){ this.productOverride.squeezeFactor = this.productReference.squeezeW; }
      this.selectedShelfPosition = this.productOverride.shelfPosition;
      this.selectedOrientation = this.productOverride.orientation;
    }
  }

  confirm() : void{
    let changed = false;
    if(this.productOverride.hFacings == this.productReference?.hFacings){
      this.productOverride.hFacings = null;
      changed = true;
    }
    if(this.productOverride.vFacings == this.productReference?.vFacings){
      this.productOverride.vFacings = null;
      changed = true;
    }
    if(this.productOverride.dFacings == this.productReference?.dFacings){
      this.productOverride.dFacings = null;
      changed = true;
    }
    if(this.productOverride.categoryFlow == this.productReference?.categoryFlow){
      this.productOverride.categoryFlow = null;
      changed = true;
    }
    this.productOverride.shelfPosition = parseInt(this.selectedShelfPosition);
    if(this.productOverride.shelfPosition == this.productReference?.shelfPosition){
      this.productOverride.shelfPosition = null;
      changed = true;
    }
    this.productOverride.orientation = parseInt(this.selectedOrientation);
    if(this.productOverride.orientation == this.productReference?.orientation){
      this.productOverride.orientation = null;
      changed = true;
    }
    if(this.productOverride.squeezeFactor == this.productReference?.squeezeW){
      this.productOverride.squeezeFactor = null;
      changed = true;
    }
    this.activeModal.close(changed ? this.productOverride : null);
  }

  cancel(): void{
    this.activeModal.close(null);
  }
}
